import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../index'

const settings = (state: RootState) => state.settings

export const settingsSelector = createSelector([settings], settings => settings)
